// src/types/senha.ts
// Tipos do contrato de TROCA OBRIGATÓRIA de senha (issue #27), alinhado ao
// backend #58 (ADR-040). Espelha o molde de `types/termos.ts`: o gate NÃO roda
// no login — a primeira request autenticada a rota protegida retorna 403 com
// `reason=senha_pendente` enquanto houver troca obrigatória pendente.
//
// Ordem dos bloqueios no backend: termos ANTES de senha. Portanto o 403 de senha
// só aparece depois do aceite dos termos (o interceptor trata os dois em ramos
// irmãos, senha depois de termos).

// `reason` do 403 que sinaliza troca de senha obrigatória pendente. Detecção é
// SEMPRE por este campo, nunca pela string da mensagem (humana e mutável).
export const SENHA_PENDENTE_REASON = 'senha_pendente';

// Motivo da pendência: senha ainda é a auto-gerada do e-mail de boas-vindas
// (primeiro_acesso) ou rotação de 3 meses vencida (expirada).
export type SenhaMotivo = 'primeiro_acesso' | 'expirada';

// Corpo do 403 de senha pendente (snake_case — espelha o backend), consumido
// pelo interceptor de `api.ts` para abrir o modal de troca obrigatória.
export interface SenhaPendenteBody {
  error?: string;
  reason?: string;
  motivo?: SenhaMotivo; // primeiro_acesso | expirada
  padrao_exigido?: string; // requisito na redação EXATA da validação do backend
  code?: string;
}
